import { Box, TextField, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import React, { useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import { COMMON_STYLE } from '../../../../Utility/Constants'
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const gonioState = {
  B_R_Inferior: '',
  B_R_Nasal: '',
  B_R_Superior: '',
  B_R_Temporal: '',
  B_L_Inferior: '',
  B_L_Nasal: '',
  B_L_Superior: '',
  B_L_Temporal: '',
  A_R_Inferior: '',
  A_R_Nasal: '',
  A_R_Superior: '',
  A_R_Temporal: '',
  A_L_Inferior: '',
  A_L_Nasal: '',
  A_L_Superior: '',
  A_L_Temporal: '',

  dup_B_R_Inferior: '',
  dup_B_R_Nasal: '',
  dup_B_R_Superior: '',
  dup_B_R_Temporal: '',
  dup_B_L_Inferior: '',
  dup_B_L_Nasal: '',
  dup_B_L_Superior: '',
  dup_B_L_Temporal: '',
  dup_A_R_Inferior: '',
  dup_A_R_Nasal: '',
  dup_A_R_Superior: '',
  dup_A_R_Temporal: '',
  dup_A_L_Inferior: '',
  dup_A_L_Nasal: '',
  dup_A_L_Superior: '',
  dup_A_L_Temporal: '',
}

const UmaGoniosopy = React.forwardRef((props, ref) => {
  const [gonio, setGonio] = useState(gonioState)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - GONIOSCOPY`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - GONIOSCOPY`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performGoniosopyAction: () => {
      let ALI = gonio.dup_A_L_Inferior === '' ? '' : JSON.parse(gonio.dup_A_L_Inferior)
      let ALN = gonio.dup_A_L_Nasal === '' ? '' : JSON.parse(gonio.dup_A_L_Nasal)
      let ALS = gonio.dup_A_L_Superior === '' ? '' : JSON.parse(gonio.dup_A_L_Superior)
      let ALT = gonio.dup_A_L_Temporal === '' ? '' : JSON.parse(gonio.dup_A_L_Temporal)
      let BLI = gonio.dup_B_L_Inferior === '' ? '' : JSON.parse(gonio.dup_B_L_Inferior)
      let BLN = gonio.dup_B_L_Nasal === '' ? '' : JSON.parse(gonio.dup_B_L_Nasal)
      let BLS = gonio.dup_B_L_Superior === '' ? '' : JSON.parse(gonio.dup_B_L_Superior)
      let BLT = gonio.dup_B_L_Temporal === '' ? '' : JSON.parse(gonio.dup_B_L_Temporal)
      let ARI = gonio.dup_A_R_Inferior === '' ? '' : JSON.parse(gonio.dup_A_R_Inferior)
      let ARN = gonio.dup_A_R_Nasal === '' ? '' : JSON.parse(gonio.dup_A_R_Nasal)
      let ARS = gonio.dup_A_R_Superior === '' ? '' : JSON.parse(gonio.dup_A_R_Superior)
      let ART = gonio.dup_A_R_Temporal === '' ? '' : JSON.parse(gonio.dup_A_R_Temporal)
      let BRI = gonio.dup_B_R_Inferior === '' ? '' : JSON.parse(gonio.dup_B_R_Inferior)
      let BRN = gonio.dup_B_R_Nasal === '' ? '' : JSON.parse(gonio.dup_B_R_Nasal)
      let BRS = gonio.dup_B_R_Superior === '' ? '' : JSON.parse(gonio.dup_B_R_Superior)
      let BRT = gonio.dup_B_R_Temporal === '' ? '' : JSON.parse(gonio.dup_B_R_Temporal)

      if (
        gonio.A_L_Inferior !== ALI || gonio.A_L_Nasal !== ALN || gonio.A_L_Superior !== ALS || gonio.A_L_Temporal !== ALT ||
        gonio.B_L_Inferior !== BLI || gonio.B_L_Nasal !== BLN || gonio.B_L_Superior !== BLS || gonio.B_L_Temporal !== BLT ||
        gonio.A_R_Inferior !== ARI || gonio.A_R_Nasal !== ARN || gonio.A_R_Superior !== ARS || gonio.A_R_Temporal !== ART ||
        gonio.B_R_Inferior !== BRI || gonio.B_R_Nasal !== BRN || gonio.B_R_Superior !== BRS || gonio.B_R_Temporal !== BRT
      ) {
        postGonioscopyData()
      }
    }
  }))

  const apicalls = async () => {
    await getGonioscopyData()
  }

  const getGonioscopyData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_GONIOSCOPY + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let gonioData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setGonio((prev) => ({
          ...prev,
          B_R_Inferior: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.RE?.inferior_grade : '',
          B_R_Nasal: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.RE?.nasal_grade : '',
          B_R_Superior: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.RE?.superior_grade : '',
          B_R_Temporal: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.RE?.temporal_grade : '',
          dup_B_R_Inferior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.RE?.inferior_grade) : '',
          dup_B_R_Nasal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.RE?.nasal_grade) : '',
          dup_B_R_Superior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.RE?.superior_grade) : '',
          dup_B_R_Temporal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.RE?.temporal_grade) : '',

          B_L_Inferior: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.LE?.inferior_grade : '',
          B_L_Nasal: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.LE?.nasal_grade : '',
          B_L_Superior: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.LE?.superior_grade : '',
          B_L_Temporal: Object.keys(gonioData)?.length > 0 ? gonioData?.before_dilation?.LE?.temporal_grade : '',
          dup_B_L_Inferior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.LE?.inferior_grade) : '',
          dup_B_L_Nasal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.LE?.nasal_grade) : '',
          dup_B_L_Superior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.LE?.superior_grade) : '',
          dup_B_L_Temporal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.before_dilation?.LE?.temporal_grade) : '',

          A_R_Inferior: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.RE?.inferior_grade : '',
          A_R_Nasal: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.RE?.nasal_grade : '',
          A_R_Superior: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.RE?.superior_grade : '',
          A_R_Temporal: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.RE?.temporal_grade : '',
          dup_A_R_Inferior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.RE?.inferior_grade) : '',
          dup_A_R_Nasal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.RE?.nasal_grade) : '',
          dup_A_R_Superior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.RE?.superior_grade) : '',
          dup_A_R_Temporal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.RE?.temporal_grade) : '',

          A_L_Inferior: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.LE?.inferior_grade : '',
          A_L_Nasal: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.LE?.nasal_grade : '',
          A_L_Superior: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.LE?.superior_grade : '',
          A_L_Temporal: Object.keys(gonioData)?.length > 0 ? gonioData?.after_dilation?.LE?.temporal_grade : '',
          dup_A_L_Inferior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.LE?.inferior_grade) : '',
          dup_A_L_Nasal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.LE?.nasal_grade) : '',
          dup_A_L_Superior: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.LE?.superior_grade) : '',
          dup_A_L_Temporal: Object.keys(gonioData)?.length > 0 ? JSON.stringify(gonioData?.after_dilation?.LE?.temporal_grade) : ''
        }))
        const checkValPresent = (obj) => obj ? Object.keys(obj)?.length > 0 : false
        const isValid = (checkValPresent(gonioData?.before_dilation?.RE) || checkValPresent(gonioData?.before_dilation?.LE) ||
          checkValPresent(gonioData?.after_dilation?.RE) || checkValPresent(gonioData?.after_dilation?.LE)
        )
        props.setAccordionOpen(isValid);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postGonioscopyData = async () => {
    try {
      let data = {
        appointment_id: props?.props?.appointment_id,
        before_dilation: {
          RE: {
            eye_type: 'RE',
            before_dilation: true,
            inferior_grade: gonio.B_R_Inferior || '',
            superior_grade: gonio.B_R_Superior || '',
            temporal_grade: gonio.B_R_Temporal || '',
            nasal_grade: gonio.B_R_Nasal || ''
          },
          LE: {
            eye_type: 'LE',
            before_dilation: true,
            inferior_grade: gonio.B_L_Inferior || '',
            superior_grade: gonio.B_L_Superior || '',
            temporal_grade: gonio.B_L_Temporal || '',
            nasal_grade: gonio.B_L_Nasal || ''
          }
        },
        after_dilation: {
          RE: {
            eye_type: 'RE',
            before_dilation: false,
            inferior_grade: gonio.A_R_Inferior || '',
            superior_grade: gonio.A_R_Superior || '',
            temporal_grade: gonio.A_R_Temporal || '',
            nasal_grade: gonio.A_R_Nasal || ''
          },
          LE: {
            eye_type: 'LE',
            before_dilation: false,
            inferior_grade: gonio.A_L_Inferior || '',
            superior_grade: gonio.A_L_Superior || '',
            temporal_grade: gonio.A_L_Temporal || '',
            nasal_grade: gonio.A_L_Nasal || ''
          }
        }
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_GONIOSCOPY)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getGonioscopyData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const textBox = (key, values, label) => {
    try {
      return (
        <TextField
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          autoComplete='off'
          size='small'
          value={values}
          sx={{ width: '6dvw' }}
          onChange={(e) => {
            let value = e.target.value
            setGonio((prev) => ({ ...prev, [key]: value }))
          }}
          InputProps={{
            emed_tid: key,
            style: { height: COMMON_STYLE.HEIGHT }
          }}
          placeholder={label}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderGonioscopyImage = (label, Inferior, Nasal, Superior, Temporal, key1, key2, key3, key4) => {
    try {
      return (
        <Box>
          <Box style={{ display: "flex", alignItems: "center", justifyContent: "center", position: "relative", height: "30vh", margin: "0.5rem" }}>
            <Box sx={{ position: "absolute", top: "0vw", zIndex: 20 }}>{textBox(key3, Superior, 'Superior')}</Box>
            <Box sx={{ position: "absolute", left: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{textBox(key2, Nasal, 'Nasal')}</Box>
            <Box sx={{ position: "absolute", right: "-2.5vw", top: "6.3vw", zIndex: 20 }}>{textBox(key4, Temporal, 'Temporal')}</Box>
            <Box sx={{ position: "absolute", bottom: "0vw", zIndex: 20 }}>{textBox(key1, Inferior, 'Inferior')}</Box>
            <Box>
              <img src={ImagePaths.GonioscopyImage.default} alt="GonioscopyImage" style={{ width: '12vw', height: '20vh' }} />
            </Box>
          </Box>
          <Typography fontSize={'0.9vw'} fontWeight={600} ml={'4rem'}>{label}</Typography>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion  expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
            <Typography className='doc_notes_header_card_font'>Gonioscopy</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component={'div'} borderBottom={'2px solid lightgray'} mt={'0.5rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'center'}>
                <Typography className='doc_notes_header_card_font'>Before Dilation</Typography>
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'space-around'} mb={'0.5rem'}>
                {renderGonioscopyImage("Right Eye (OD)", gonio.B_R_Inferior, gonio.B_R_Nasal, gonio.B_R_Superior, gonio.B_R_Temporal,
                  'B_R_Inferior', 'B_R_Nasal', 'B_R_Superior', 'B_R_Temporal')}
                {renderGonioscopyImage("Left Eye (OS)", gonio.B_L_Inferior, gonio.B_L_Nasal, gonio.B_L_Superior, gonio.B_L_Temporal,
                  'B_L_Inferior', 'B_L_Nasal', 'B_L_Superior', 'B_L_Temporal')}
              </Box>
            </Box>
            <Box component={'div'} mt={'0.5rem'}>
              <Box component={'div'} display={'flex'} justifyContent={'center'}>
                <Typography className='doc_notes_header_card_font'>After Dilation</Typography>
              </Box>
              <Box component={'div'} display={'flex'} justifyContent={'space-around'} mb={'0.5rem'}>
                {renderGonioscopyImage("Right Eye (OD)", gonio.A_R_Inferior, gonio.A_R_Nasal, gonio.A_R_Superior, gonio.A_R_Temporal,
                  'A_R_Inferior', 'A_R_Nasal', 'A_R_Superior', 'A_R_Temporal')}
                {renderGonioscopyImage("Left Eye (OS)", gonio.A_L_Inferior, gonio.A_L_Nasal, gonio.A_L_Superior, gonio.A_L_Temporal,
                  'A_L_Inferior', 'A_L_Nasal', 'A_L_Superior', 'A_L_Temporal')}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaGoniosopy